<template>
  <!--  详情页 -->
  <div class="fourlist">
    <!-- <div class="alltodo" ref="soncpnts" :style="getThemeStyle()"> -->
    <div class="alltodo" ref="soncpnts" >
      <div class="nav">
        <div class="nav-lt">
          <!-- <img
            class="nav-lt-img"
            src="../../assets/img/home/center/whole.png"
            alt=""
          /> -->
          <div class="nav-lt-tit">分析总结</div>
        </div>
        <!-- <div class="nav-rt">
          <el-switch
            class="nav-rt-sw"
            v-model="switchVal"
            :width="33"
            active-color="#13ce66"
            inactive-color="#bbbbbc"
            @change="switchChang"
          >
          </el-switch>
          <div class="nav-rt-txt">显示已完成</div>
        </div> -->
      </div>

      <div ref="heightCtr" class="height-cotr">
        <el-container>
          <el-container>
            <el-header>
              <el-card class="topbar bgblock">
                <div class="topbar-box">
                  <div>
                    <span class="title">总创建</span
                    ><span class="count">300</span>
                  </div>
                  <div>
                    <span class="title">已完成</span
                    ><span class="count">289</span>
                  </div>
                  <div>
                    <span class="title">使用天数</span
                    ><span class="count">209</span>
                  </div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div class="describe">
                    已超过<span class="describe-count">20%</span>用户
                  </div>
                </div>
              </el-card></el-header
            >
            <el-main style="padding-bottom: 0"
              ><div
                class="bgblock"
                style="height: 100%; border: 1px solid #fff"
                ref="charts"
              >
                <!-- <canvas width="100%" height="100%" style="border:1px solid #fff;" >
                </canvas> -->
                成长值分析图表
              </div></el-main
            >
          </el-container>
          <el-aside width="316px" style=" margin-right: 20px">
            <el-card
              class="box-card bgblock"
              style="
                color: #f00;
                font-family: PingFang-SC-Bold;
                font-size: 26px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #cccccc;
              "
            >
              <div class="clearfix" style="line-height: 60px">
                <span>等级说明</span>
              </div>
              <div class="grade">
                <div class="grade-title"><span>等级</span></div>
                <div class="grade-title"><span>名称</span></div>
                <div class="grade-title"><span>成长值</span></div>
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 5px 0;
                "
              >
                <div
                  style="width: 350px; height: 1px; background-color: #424242"
                ></div>
              </div>
              <div>
                <div
                  v-for="(item, index) in gradeList"
                  :key="index"
                  class="grade"
                >
                  <div class="grade-table">
                    <span>{{ item.lv }}</span>
                  </div>
                  <div class="grade-table">
                    <span>{{ item.name }}</span>
                  </div>
                  <div class="grade-table">
                    <span>{{ item.price }}</span>
                  </div>
                </div>
              </div>
            </el-card>
          </el-aside>
        </el-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {
  },
  data() {
    return {
      // value1: '',
      // //控制右侧边栏
      // alltodoItem: false,
      // //控制显示隐藏
      // switchVal: false,
      // //当前点击项
      // eegt: '',
      // itemdata: [],
      // visible: false,
      // tranLeft: '',
      // tranTop: '',
      // addbottom: '',
      // indexlist: -1,
      // //传给右侧边栏的
      // detailsTodo: {},
      // //控制重复按钮
      // dispno: false,
      // repeatnumb: 1,
      // repeatitem: ['无', '每天', '每周工作日', '每周', '每月', '每年'],
      // //控制选择四象限按钮
      // fourdisp: false,
      // fournumb: 4,
      // fourtitem: ['重要紧急', '重要不紧急', '不重要紧急', '不重要不紧急'],
      // //控制点击完成动画
      // deleLine: -1,

      gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => {
        return {
          lv: `lv${item}`,
          name: `青铜${item}`,
          price: `${item}~${item * 50}`
        }
      })
    }
  },
  created() {
    // this.bgtet = this.$route.query.tet;
    // this.fourdata(this.bgtet);
  },
  watch: {
    $route(val) {
      // this.bgtet = this.$route.query.tet;
      // this.fourdata(this.bgtet);
    }
  },
  mounted() {
    const lastWeekDays = this.$util.lastWeekDays()
    //最后加个100是为了在所有数字都小于100的时候不会自动撑满
    const values = [10, 40, 12, 89, 64, 43, 20, 100]

    const option = {
      title: {
        show: true,
        text: '成长值分析',
        left: 30,
        textStyle: {
          fontSize: 26,
          fontFamily: 'PingFang-SC-Bold',
          color: '#cccccc',
          lineHeight: 100,
          textShadowColor: '#f00'
        }
      },
      grid: {
        left: 80,
        right: 20,
        top: 100,
        bottom: 60
      },
      xAxis: {
        type: 'category',
        data: lastWeekDays,
        axisLabel: {
          textStyle: {
            fontFamily: 'PingFang-SC-Medium',
            fontSize: 18,
            fontWeight: 'bold',
            color: '#6f6f6f',
            lineHeight:50
          }
        }
      },
      yAxis: {
        type: 'value',
        splitLine: {
          // show: false,
          lineStyle: {
            color: ['#424242']
          }
        },
        axisLabel: {
          textStyle: {
            fontFamily: 'PingFang-SC-Medium',
            fontSize: 18,
            fontWeight: 'bold',
            color: '#6f6f6f',
          }
        }
      },
      series: [
        {
          data: values,
          type: 'bar',
          barWidth: '20',
          showBackground: true,
          backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)'
          }
        }
      ]
    }

    this.$initEcharts(this.$refs.charts, option).getWidth()
    // setTimeout(() => {
    //   values.unshift(values.pop())
    //    this.$initEcharts(this.$refs.charts, option)
    // }, 1000);
  },
  methods: {
    ...mapGetters('theme', ['getThemeStyle', 'getTheme'])
    //请求数据
    // fourdata(tet) {

    //   console.log(this.bgtet, "请求数据");
    //   if (tet == "重要紧急") {
    //     this.forudt(0);
    //     this.bgcolo = "#ec7259";
    //   } else if (tet == "重要不紧急") {
    //     this.forudt(1);
    //     this.bgcolo = "#f6a801";
    //   } else if (tet == "不重要紧急") {
    //     this.forudt(2);
    //     this.bgcolo = "#b78efc";
    //   } else if (tet == "不重要不紧急") {
    //     this.forudt(3);
    //     this.bgcolo = "#90d034";
    //   } else if (tet == "今天") {
    //     this.today();
    //     this.bgcolo = "#f2f4f8";
    //   } else if (tet == "未来七天") {
    //     this.bgcolo = "#f2f4f8";
    //     this.futureday();
    //   } else if (tet == "自定义") {
    //     this.bgcolo = "#f2f4f8";
    //     console.log(this.$route.query);
    //     this.bgtet = this.$route.query.name;
    //     this.futurcustom(this.$route.query.from_id);
    //   }
    // },
    // delet() {
    //   console.log('重新查询')
    //   this.fourdata(this.$route.query.tet)
    // },
    // //api查询四象限
    // forudt(p) {
    //   let header = {
    //     Authorization: 'Bearer ' + localStorage.getItem('token')
    //   }
    //   this.$api
    //     .fourquadrcation(p, header)
    //     .then((res) => {
    //       console.log(res, 'ggggggg')
    //       this.itemdata = res.data.result
    //       this.deleLine = -1
    //     })
    //     .catch((err) => {})
    // },
    // //获取当前时间
    // getTime() {
    //   let date = new Date()
    //   var seperator1 = '-'
    //   var seperator2 = ':'
    //   //以下代码依次是获取当前时间的年月日时分秒
    //   var year = date.getFullYear()
    //   var month = date.getMonth() + 1
    //   var strDate = date.getDate()
    //   var minute = date.getMinutes()
    //   var hour = date.getHours()
    //   var second = date.getSeconds()
    //   //固定时间格式
    //   if (month >= 1 && month <= 9) {
    //     month = '0' + month
    //   }
    //   if (strDate >= 0 && strDate <= 9) {
    //     strDate = '0' + strDate
    //   }
    //   if (hour >= 0 && hour <= 9) {
    //     hour = '0' + hour
    //   }
    //   if (minute >= 0 && minute <= 9) {
    //     minute = '0' + minute
    //   }
    //   if (second >= 0 && second <= 9) {
    //     second = '0' + second
    //   }
    //   var currentdate = year + seperator1 + month + seperator1 + strDate
    //   // "/" +
    //   // hour +
    //   // seperator2 +
    //   // minute +
    //   // seperator2 +
    //   // second;
    //   return currentdate
    // },
    // //查询今天的清单
    // today() {
    //   let header = {
    //     Authorization: 'Bearer ' + localStorage.getItem('token')
    //   }
    //   this.$api
    //     .todaytwo(this.getTime(), header)
    //     .then((res) => {
    //       this.itemdata = res.data.results
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    // //查询未来七天的清单
    // futureday() {
    //   let header = {
    //     Authorization: 'Bearer ' + localStorage.getItem('token')
    //   }
    //   this.$api
    //     .futureday('', header)
    //     .then((res) => {
    //       this.itemdata = res.data.result
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    // //查询自定义清单
    // futurcustom(index) {
    //   console.log(index, '清单id')
    //   let header = {
    //     Authorization: 'Bearer ' + localStorage.getItem('token')
    //   }
    //   this.$api
    //     .customquadrcation(index, header)
    //     .then((res) => {
    //       console.log(res, '自定义清单的')
    //       this.itemdata = res.data.result
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    // // 显示隐藏
    // switchChang(e) {
    //   console.log(e, '点击的switch的值')
    //   this.switchVal = e
    // },
    // //清单条目点击事件
    // todorigClick(index, item) {
    //   console.log(index, '点击了')
    //   if (this.eegt != index) {
    //     this.alltodoItem = true
    //     this.sideWidth(item)
    //     this.eegt = index
    //   } else {
    //     this.alltodoItem = !this.alltodoItem
    //     this.sideWidth(item)
    //   }
    // },
    // //点击已完成
    // chooseCheak(item, index) {
    //   console.log(index, 77777777)
    //   this.deleLine = index
    //   var that = this
    //   setTimeout(function () {
    //     let header = {
    //       Authorization: 'Bearer ' + localStorage.getItem('token')
    //     }
    //     let data = {
    //       todo_id: item.id
    //     }
    //     that.$api
    //       .completed(data, header)
    //       .then((res) => {
    //         that.fourdata(that.$route.query.tet)
    //         console.log(res, '点击已完成')
    //       })
    //       .catch((err) => {
    //         console.log(err)
    //       })
    //   }, 1000)
    // },
    // addsubmit(data) {
    //   let header = {
    //     Authorization: 'Bearer ' + localStorage.getItem('token')
    //   }

    //   this.$api
    //     .releasetodo(data, header)
    //     .then((res) => {
    //       console.log(res, '发布清单')
    //       this.fourdata(this.$route.query.tet)
    //       this.addbottom = ''
    //       this.fournumb = 4
    //       this.repeatnumb = 1
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    // //发布清单
    // submit() {
    //   if (this.addbottom != '') {
    //     console.log(this.$route.query.tet)
    //     if (this.$route.query.tet == '自定义') {
    //       console.log('自定义')
    //       if (this.value1 == '') {
    //         let data = {
    //           task_name: this.addbottom,
    //           type: this.fournumb - 1,
    //           task_repeat: this.repeatnumb - 1,
    //           todo_from: this.$route.query.from_id
    //         }
    //         this.addsubmit(data)
    //       } else {
    //         let data = {
    //           task_name: this.addbottom,
    //           type: this.fournumb - 1,
    //           task_repeat: this.repeatnumb - 1,
    //           task_time: this.value1,
    //           todo_from: this.$route.query.from_id
    //         }
    //         this.addsubmit(data)
    //       }
    //     } else if (this.$route.query.tet == '今天') {
    //       console.log('发布今天的清单')
    //       if (this.value1 == '') {
    //         let data = {
    //           task_name: this.addbottom,
    //           type: this.fournumb - 1,
    //           task_repeat: this.repeatnumb - 1,
    //           task_time: this.getTime()
    //         }
    //         console.log(data, '发布今天的清单')
    //         this.addsubmit(data)
    //       } else {
    //         let data = {
    //           task_name: this.addbottom,
    //           type: this.fournumb - 1,
    //           task_repeat: this.repeatnumb - 1,
    //           task_time: this.value1
    //         }
    //         console.log(data, '发布今天的清单')
    //         this.addsubmit(data)
    //       }
    //     } else {
    //       console.log('不是自定义')
    //       if (this.value1 == '') {
    //         console.log('没有时间')
    //         let data = {
    //           task_name: this.addbottom,
    //           type: this.fournumb - 1,
    //           task_repeat: this.repeatnumb - 1
    //         }
    //         this.addsubmit(data)
    //       } else {
    //         console.log('有时间')
    //         let data = {
    //           task_name: this.addbottom,
    //           type: this.fournumb - 1,
    //           task_repeat: this.repeatnumb - 1,
    //           task_time: this.value1
    //         }
    //         this.addsubmit(data)
    //       }
    //     }
    //     console.log(this.value1, '发布')
    //   }
    // },
    // //重复按钮
    // repeatclick() {
    //   console.log(this.dispno)
    //   this.dispno = !this.dispno
    //   this.fourdisp = false
    // },
    // //选择象限按钮
    // fourclick() {
    //   this.fourdisp = !this.fourdisp
    //   this.dispno = false
    // },
    // sonPackup() {
    //   this.alltodoItem = false
    //   this.sideWidth()
    // },
    // //全部待办点击事件
    // sideWidth(item) {
    //   if (this.alltodoItem) {
    //     this.$refs.soncpnts.style.width = '58%'
    //     this.$refs.rightcpnts.style.display = 'block'
    //     console.log(item)
    //     this.detailsTodo = item
    //     console.log(this.detailsTodo, 'oooooooo')
    //   } else {
    //     this.$refs.soncpnts.style.width = '81%'
    //     this.$refs.rightcpnts.style.display = 'none'
    //   }
    // },

    // show111(e, index) {
    //   console.log(index, this.indexlist)
    //   if (index == this.indexlist) {
    //     this.visible = false
    //     // this.visible = true
    //   } else {
    //     this.indexlist = index
    //     this.visible = true
    //   }
    //   let tlet = document.getElementsByClassName('idpop')
    //   console.log(tlet)
    //   this.tranLeft = e.pageX - 300 + 'px'
    //   this.tranTop = e.pageY + 'px'
    // },
    // homeclick() {
    //   this.visible = false
    //   this.dispno = false
    //   this.fourdisp = false
    // }
  }
}
</script>

<style lang="scss" scoped>
.bgblock {
  background-color: #323232;
  border: none;
  border-radius: 10px;
}

.fourlist {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;


  .rightcontent {
    width: 23%;
    height: 100%;
    display: none;
  }
  .nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 50px;
    margin-bottom: 10px;
    height: 40px;
    padding: 0 4%;

    &-lt {
      display: flex;
      align-items: center;
      &-img {
        width: 20px;
        height: 16px;
        margin: 0 35px 0 0;
      }

      &-tit {
        font-size: 30px;
        font-weight: bold;
        // color: #666666;
      }
    }

    &-rt {
      display: flex;
      align-items: center;

      &-sw {
        width: 33px;
        height: 16px;
        span {
          height: 16px;
        }

        .el-switch__core {
          height: 16px !important;
        }
        .el-switch__core::after {
          height: 13px !important;
          width: 13px !important;
        }
      }

      &-txt {
        font-size: 16px;
        color: #666666;
        margin: 0 0 0 6px;
      }
    }
  }
  .alltodo {
    position: relative;
    width: 100%;
    height: 100%;
     background-color: var(--color-theme);
    .height-cotr {
      height: calc(100% - 100px);
      overflow-y: auto;
      // padding: 0 4% 0 0;

      .topbar {
        .topbar-box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-family: PingFang-SC-Medium;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 8px;
            letter-spacing: 0px;
            color: #6f6f6f;
          }
          .count {
            margin-left: 10px;
            font-family: PingFang-SC-Bold;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 8px;
            letter-spacing: 0px;
            color: #cccccc;
          }
          .describe {
            font-family: PingFang-SC-Medium;
            font-size: 20px;
            font-weight: bold;
            font-stretch: normal;
            line-height: 8px;
            letter-spacing: 0px;
            color: #6f6f6f;
            .describe-count {
              font-family: PingFang-SC-Medium;
              font-size: 20px;
              font-weight: bold;
              letter-spacing: 0px;
              color: #4973f5;
            }
          }
        }
      }
      .grade {
        display: flex;
        justify-content: space-between;
        height: 45px;
        align-items: center;
        &-title {
          font-family: PingFang-SC-Medium;
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #999999;
          flex: 1;
          text-align: center;
        }

        &-table {
          font-family: PingFang-SC-Medium;
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #cccccc;
          flex: 1;
          text-align: center;
        }
      }
    }
    .height-cotr::-webkit-scrollbar {
      width: 4px;
    }
    .height-cotr::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.2);
    }

    // .idpop {
    //   position: absolute;
    //   z-index: 2000;
    //   height: 50px;
    //   width: 210px;
    //   background-color: #fff;
    //   box-shadow: 0px 4px 32px 3px rgba(0, 0, 0, 0.19);
    //   display: flex;
    //   align-items: center;
    //   img {
    //     margin: 0 30px;
    //   }
    // }

    .alltodo_content {
      .center_title {
        display: block;
        width: 100%;
        text-align: center;
        margin: 15px 0;
      }
      .alltodo_outer {
        width: 100%;
      }
      .alltodo_list {
        display: flex;
        align-items: center;
        border-radius: 7px;
        width: 100%;
        background-color: #fff;
        height: 57px;
        margin: 20px 0;
        overflow: hidden;
        i {
          display: block;
          width: 3px;
          height: 18px;
          background-color: #90d034;
          margin-left: 10px;
        }
        .min_img {
          width: 21px;
          height: 21px;
          margin: 0 20px;
        }
        .min_list {
          .alltodo_list_content {
            font-size: 15px;
          }
          div {
            display: flex;
            margin-top: 8px;
            font-size: 13px;
            img {
              margin-left: 12px;
            }
          }
        }
      }
      .delecls {
        text-decoration: line-through;
        opacity: 0.6;
        width: 0;
        padding: 0;
        transition: width 1s linear;
      }
    }
    // .main_bt_img {
    //   width: 100%;
    //   text-align: center;
    //   margin-top: 15%;
    //   img {
    //     width: 280px;
    //     height: 215px;
    //   }
    // }
  }
}
</style>